var _g, _circle, _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _circle2, _rect2, _path8, _path9, _mask, _path10, _path11, _path12, _path13, _path14, _mask2, _path15, _path16, _path17, _rect3, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoBundlesAvailable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 32,
    viewBox: "0 0 164 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 13.091,
    fill: "#F4E2F3"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 13.841,
    stroke: "url(#b)",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.546 6.545c2.322 2.232 5.697 3.637 9.454 3.637 3.757 0 7.132-1.405 9.455-3.637",
    stroke: "#BD55B8",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.546 25.455c2.322-2.232 5.697-3.637 9.454-3.637 3.757 0 7.132 1.405 9.455 3.637",
    stroke: "#9C4EB2",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 29.84c2.404 0 4.423-1.745 5.798-4.22 1.39-2.5 2.225-5.902 2.225-9.62 0-3.718-.836-7.121-2.225-9.621-1.375-2.475-3.394-4.22-5.798-4.22s-4.423 1.745-5.798 4.22c-1.39 2.5-2.225 5.903-2.225 9.62 0 3.719.836 7.122 2.225 9.622 1.375 2.474 3.394 4.22 5.798 4.22z",
    stroke: "url(#c)",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.182v27.273M29.818 16h-28",
    stroke: "#BD55B8",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    transform: "rotate(13 56.818 2.474)",
    fill: "url(#d)",
    d: "M56.818 2.474h13.818v25.454H56.818z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55.351,
    y: 1.771,
    width: 16,
    height: 26.182,
    rx: 4,
    transform: "rotate(13 55.351 1.771)",
    stroke: "url(#e)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fill: "#6AC34B",
    d: "m68.503 5.184 2.126.49-5.726 24.803-2.126-.491z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m50.596 21.491 16.273 3.877",
    stroke: "url(#f)",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.02,
    cy: 26.324,
    r: 1.091,
    transform: "rotate(13 58.02 26.324)",
    fill: "#0FBDB6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61.231,
    y: 5.308,
    width: 3.636,
    height: 1.5,
    rx: 0.75,
    transform: "rotate(13 61.23 5.308)",
    fill: "#51C244"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3E7EE",
    d: "M115.752 11.837h2.27V28.04h-2.27z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.543 12.01a2 2 0 0 1 1.987 2.025l-.073 5.938.022 7.134-3.928-2.18.018-.03-11.782-.016a1 1 0 0 1-.999-1V12.919a1 1 0 0 1 1.007-1l13.748.091z",
    fill: "#D6F3F3"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.083 10.879a4 4 0 0 1 4 4v7.268c0 .084-.003.168-.008.25l.029-.016-.039 5.921c-.005.782-.837 1.276-1.494.886l-5.129-3.041h-9.148a4 4 0 0 1-4-4V11.879a1 1 0 0 1 1-1h14.789z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m119.075 22.397.73 1.31-2.397 1.337.17-2.74 1.497.093zm.029-.016-.731-1.31 2.247-1.253-.016 2.573-1.5-.01zm-.039 5.921-1.5-.01 1.5.01zm-1.494.886-.765 1.29.765-1.29zm-5.129-3.041v-1.5h.411l.354.21-.765 1.29zm-13.148-4h-1.5 1.5zm0-10.268h1.5-1.5zm18.289 3a2.5 2.5 0 0 0-2.5-2.5v-3a5.5 5.5 0 0 1 5.5 5.5h-3zm0 7.268v-7.268h3v7.268h-3zm-.005.158c.003-.052.005-.105.005-.158h3c0 .115-.004.23-.011.343l-2.994-.185zm2.256 1.387-.029.015-1.461-2.62.029-.016 1.461 2.62zm-2.269 4.6.039-5.92 3 .02-.039 5.92-3-.02zm.771-.394a.54.54 0 0 0-.539-.004.476.476 0 0 0-.232.399l3 .02c-.012 1.855-2.035 3.188-3.759 2.166l1.53-2.58zm-5.129-3.042 5.129 3.042-1.53 2.58-5.13-3.041 1.531-2.58zm-9.913-.21h9.148v3h-9.148v-3zm-2.5-2.5a2.5 2.5 0 0 0 2.5 2.5v3a5.5 5.5 0 0 1-5.5-5.5h3zm0-10.267v10.268h-3V11.879h3zm-.5.5a.5.5 0 0 0 .5-.5h-3a2.5 2.5 0 0 1 2.5-2.5v3zm14.789 0h-14.789v-3h14.789v3z",
    fill: "url(#g)",
    mask: "url(#h)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.647 11.496v11.43a1.829 1.829 0 0 0 .608 1.528c.353.311.811.465 1.274.428h.808a1.671 1.671 0 0 1-.64-.202 1.715 1.715 0 0 1-.517-.439 1.785 1.785 0 0 1-.315-.61 1.839 1.839 0 0 1-.065-.689V11.474h-.66a1.489 1.489 0 0 0-.174.008l-.319.014z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.526 3.724a2 2 0 0 0-1.987 2.026l.076 6.038-.022 7.034 4.035-2.181-.02-.03 12.131-.016a1 1 0 0 0 .998-1V4.633a1 1 0 0 0-1.006-1l-14.205.091z",
    fill: "#D6F4F3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M108.069 3.522v11.43a1.814 1.814 0 0 1-.625 1.528 1.79 1.79 0 0 1-1.309.427h-.829a1.752 1.752 0 0 0 1.188-.64c.147-.18.257-.387.323-.61.067-.223.09-.457.067-.689V3.5h.678c.06 0 .12.002.179.007l.328.015z",
    fill: "#B3E7EE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m95.372 8.41 8.513-.053M95.372 12.409l8.513-.053",
    stroke: "#18C8C3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.92 2.593a4 4 0 0 0-4 4v7.268c0 .085.003.169.008.252l-.032-.017.04 5.963a1 1 0 0 0 1.497.865l5.306-3.063h9.51a4 4 0 0 0 4-4V3.593a1 1 0 0 0-1-1H92.92z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m88.928 14.113-.716 1.318 2.381 1.293-.168-2.704-1.497.093zm-.032-.017.716-1.318-2.233-1.212.017 2.54 1.5-.01zm.04 5.963-1.5.01 1.5-.01zm1.497.865.75 1.3-.75-1.3zm5.306-3.063v-1.5h-.401l-.348.2.75 1.3zm13.51-4h1.5-1.5zm0-10.268h-1.5 1.5zm-18.829 3a2.5 2.5 0 0 1 2.5-2.5v-3a5.5 5.5 0 0 0-5.5 5.5h3zm0 7.268V6.593h-3v7.268h3zm.005.159a2.533 2.533 0 0 1-.005-.16h-3c0 .117.004.232.01.346l2.995-.186zm-2.244 1.394.031.017 1.432-2.636-.032-.017-1.431 2.636zm2.255 4.635-.04-5.963-3 .02.04 5.963 3-.02zm-.753-.424a.5.5 0 0 1 .753.424l-3 .02c.013 1.903 2.075 3.12 3.747 2.154l-1.5-2.598zm5.306-3.063-5.306 3.063 1.5 2.598 5.306-3.063-1.5-2.598zm10.26-.201h-9.51v3h9.51v-3zm2.5-2.5a2.5 2.5 0 0 1-2.5 2.5v3a5.5 5.5 0 0 0 5.5-5.5h-3zm0-10.268v10.268h3V3.593h-3zm.5.5a.5.5 0 0 1-.5-.5h3a2.5 2.5 0 0 0-2.5-2.5v3zm-15.329 0h15.329v-3H92.92v3z",
    fill: "url(#i)",
    mask: "url(#j)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M154.56 2.284c2.5.667 7.519 3.836 7.588 11.18M152.546 6.165c1.649.397 4.983 2.247 5.134 6.47",
    stroke: "#00A6CE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCF4E8",
    d: "m141.792 7.232 10.922 3.363-5.685 19.276-10.922-3.363z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 13.862,
    height: 21.327,
    rx: 2,
    transform: "matrix(.95573 .29426 -.28288 .95915 139.82 5.865)",
    stroke: "url(#k)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m144.084 11.2 3.059.935M138.087 23.993l5.099 1.559",
    stroke: "#00A6CE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 16,
    y1: 2.909,
    x2: 16,
    y2: 29.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D95BBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C4AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 16,
    y1: 2.909,
    x2: 16,
    y2: 29.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D95BBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C4AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 63.617,
    y1: 1.354,
    x2: 64.367,
    y2: 28.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 63.351,
    y1: 1.771,
    x2: 63.351,
    y2: 27.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 61.458,
    y1: 11.883,
    x2: 58.719,
    y2: 23.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 113.26,
    y1: 8.665,
    x2: 101.799,
    y2: 30.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18C8C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 94.9,
    y1: 0.377,
    x2: 106.202,
    y2: 22.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18C8C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 14.05,
    y1: -4.189,
    x2: 2.767,
    y2: -3.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 1.409,
    y: 1.409,
    width: 29.182,
    height: 29.182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.905882 0 0 0 0 0.752941 0 0 0 0 0.894118 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_1864_30513"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_1864_30513",
    result: "effect2_innerShadow_1864_30513"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBundlesAvailable);
export default __webpack_public_path__ + "static/media/noBundlesAvailable.efbb95bed639044e54cdcb9ed7d15557.svg";
export { ForwardRef as ReactComponent };